/* eslint-disable max-classes-per-file */
/* eslint-disable no-useless-constructor */
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import {
  MultiSelectFieldEvent,
  SingleSelectFieldEvent,
} from '@rover/shared/js/eventstream/FormFieldAnalytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * Base class for Search Interstitial AnalyticsEvents
 */
export abstract class SearchInterstitialAnalyticsEvent extends AnalyticsEvent {
  abstract eventName: string;

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.recommendations.browse_search;
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a person chooses pet type on search modal
 *
 * &nbsp;
 */
export class SearchInterstitialUpdatePetType extends MultiSelectFieldEvent {
  concept = CONCEPTS.recommendations.browse_search;

  eventName = 'search-interstitial-update-pet-type';

  eventProperties: { dog: boolean; cat: boolean; puppy: boolean };

  constructor(eventProperties: { dog: boolean; cat: boolean; puppy: boolean }) {
    super(eventProperties);
    this.eventProperties = eventProperties;
  }
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a person chooses service type on search modal
 *
 * &nbsp;
 */
export class SearchInterstitialUpdateServiceType extends SingleSelectFieldEvent {
  concept = CONCEPTS.recommendations.browse_search;

  eventName = 'search-interstitial-update-service-type';

  eventProperties: { serviceType: string };

  constructor(eventProperties: { serviceType: string }) {
    super(eventProperties);
    this.eventProperties = eventProperties;
  }
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a person updates location on search modal
 *
 * &nbsp;
 */
export class SearchInterstitialUpdateLocation extends SearchInterstitialAnalyticsEvent {
  eventName = 'search-interstitial-update-location';
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a person selects dates on search modal
 *
 * &nbsp;
 */
export class SearchInterstitialSelectDates extends SearchInterstitialAnalyticsEvent {
  eventName = 'search-interstitial-select-dates';
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a person updates size on search modal
 *
 * &nbsp;
 */
export class SearchInterstitialUpdateSize extends MultiSelectFieldEvent {
  concept = CONCEPTS.recommendations.browse_search;

  eventName = 'search-interstitial-update-size';

  eventProperties: {
    smallDogs: boolean;
    mediumDogs: boolean;
    largeDogs: boolean;
    giantDogs: boolean;
  };

  constructor(eventProperties: {
    smallDogs: boolean;
    mediumDogs: boolean;
    largeDogs: boolean;
    giantDogs: boolean;
  }) {
    super(eventProperties);
    this.eventProperties = eventProperties;
  }
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a person selects age on search modal
 *
 * &nbsp;
 */
export class SearchInterstitialSelectAge extends SingleSelectFieldEvent {
  concept = CONCEPTS.recommendations.browse_search;

  eventName = 'search-interstitial-select-age';

  eventProperties: { age: 'adult' | 'puppy' };

  constructor(eventProperties: { age: 'adult' | 'puppy' }) {
    super(eventProperties);
    this.eventProperties = eventProperties;
  }
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a person indicates the pet gets along with cats on search modal
 *
 * &nbsp;
 */
export class SearchInterstitialGetsAlongCats extends SingleSelectFieldEvent {
  concept = CONCEPTS.recommendations.browse_search;

  eventName = 'search-interstitial-gets-along-cats';

  eventProperties: { getsAlongCats: 'yes' | 'no' | 'unsure' };

  constructor(eventProperties: { getsAlongCats: 'yes' | 'no' | 'unsure' }) {
    super(eventProperties);
    this.eventProperties = eventProperties;
  }
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a person indicates the pet gets along with dogs on search modal
 *
 * &nbsp;
 */
export class SearchInterstitialGetsAlongDogs extends SingleSelectFieldEvent {
  concept = CONCEPTS.recommendations.browse_search;

  eventName = 'search-interstitial-gets-along-dogs';

  eventProperties: { getsAlongDogs: 'yes' | 'no' | 'unsure' };

  constructor(eventProperties: { getsAlongDogs: 'yes' | 'no' | 'unsure' }) {
    super(eventProperties);
    this.eventProperties = eventProperties;
  }
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a person updates the pet counter on search modal
 *
 * &nbsp;
 */
export class SearchInterstitialPetCounter extends SearchInterstitialAnalyticsEvent {
  eventName = 'search-interstitial-pet-counter';

  constructor(eventProperties: { petCounter: number }) {
    super(eventProperties);
  }
}
